import type {
  AppApi,
  AppRole,
  AdminUgcApi,
  AdminImageGenApi,
  AdminVideoGenApi,
  AdminSpriteGenApi,
  AdminAudioGenApi,
  AdminThreeDGenApi,
  ImageGenEntry,
  ImageGenReport,
  VideoGenEntry,
  VideoGenReport,
  SpriteGenEntry,
  SpriteGenReport,
  AudioGenEntry,
  AudioGenReport,
  ThreeDGenEntry,
  ThreeDGenReport,
  ReleaseNote,
} from './AppApi'
import type { LaunchIntent, ResolveLaunchIntentOptions } from './LaunchIntent'
import { authedFetch } from './httpUtils'
import { HttpAdminUgcApi } from './HttpAdminUgcApi'
import { createHttpAdminGenApi } from './httpAdminGen'

export class HttpAppApi implements AppApi {
  private readonly appId: string
  readonly adminUgc: AdminUgcApi
  readonly adminImageGen: AdminImageGenApi
  readonly adminVideoGen: AdminVideoGenApi
  readonly adminSpriteGen: AdminSpriteGenApi
  readonly adminAudioGen: AdminAudioGenApi
  readonly adminThreeDGen: AdminThreeDGenApi

  constructor(appId: string) {
    this.appId = appId
    this.adminUgc = new HttpAdminUgcApi(appId)
    this.adminImageGen = createHttpAdminGenApi<ImageGenEntry, ImageGenReport>('imagegen', appId)
    this.adminVideoGen = createHttpAdminGenApi<VideoGenEntry, VideoGenReport>('videogen', appId)
    this.adminSpriteGen = createHttpAdminGenApi<SpriteGenEntry, SpriteGenReport>('spritegen', appId)
    this.adminAudioGen = createHttpAdminGenApi<AudioGenEntry, AudioGenReport>('audiogen', appId)
    this.adminThreeDGen = createHttpAdminGenApi<ThreeDGenEntry, ThreeDGenReport>('threedgen', appId)
  }

  async getMyRole(): Promise<AppRole> {
    const response = await authedFetch(
      `/v1/games/${this.appId}/my-role`,
      { method: 'GET' },
    )
    const data = (await response.json()) as { role: AppRole }
    return data.role
  }

  async resolveLaunchIntent(
    _options?: ResolveLaunchIntentOptions,
  ): Promise<LaunchIntent> {
    return { kind: 'none', params: {} }
  }

  async getReleaseNotesAsync(): Promise<ReleaseNote[]> {
    const response = await authedFetch(
      `/v1/games/${this.appId}/release-notes`,
      { method: 'GET' },
    )
    const data = (await response.json()) as { releaseNotes?: ReleaseNote[] }
    return data.releaseNotes ?? []
  }

  async openReleaseNotesAsync(): Promise<void> {
    // No host info page outside the native app.
  }
}
